import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useTranslation } from 'react-i18next';
import { OfflineBudgetTableRowData } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import { formatNumberWithSpaces } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/formatNumberWithSpaces';
import {
  Box,
  Collapse,
  IconButton,
  SxProps,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import NestedBudgetTable from 'pages/calculator/MediaPlanning/common/BudgetTable/OfflineBudgetTable/NestedBudgetTable/NestedBudgetTable';
import convertDecimalToPercentValue from '../../../../Plan/Countries/utils/convertDecimalToPercentValue';

interface BudgetTableRowProps {
  rowData: OfflineBudgetTableRowData;
  sx?: SxProps;
}

function BudgetTableRow({ rowData, sx }: BudgetTableRowProps) {
  const [isRowOpen, setIsRowOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <TableRow sx={{ borderBottom: isRowOpen ? 'none' : '1px solid', ...sx }}>
        <TableCell>
          <IconButton
            size="small"
            sx={{ color: 'common.black' }}
            onClick={() => setIsRowOpen(!isRowOpen)}
          >
            {isRowOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="left">
          <Typography
            variant="body2"
            fontWeight={700}
            textTransform="uppercase"
          >
            {t(rowData.touchpoint)}
          </Typography>
        </TableCell>
        <TableCell />
        <TableCell align="right">
          <Typography variant="body2" fontWeight={700}>
            {rowData.tvReachOne
              ? `${convertDecimalToPercentValue(rowData.tvReachOne)}%`
              : ''}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <Typography variant="body2" fontWeight={700}>
            {rowData.tvReachThree
              ? `${convertDecimalToPercentValue(rowData.tvReachThree)}%`
              : ''}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <Typography variant="body2" fontWeight={700}>
            {rowData.grp ? formatNumberWithSpaces(rowData.grp) : ''}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <Typography variant="body2" fontWeight={700}>
            {rowData.weeks ? formatNumberWithSpaces(rowData.weeks) : ''}
          </Typography>
        </TableCell>
        <TableCell align="right">
          <Typography variant="body2" fontWeight={700}>
            {`${formatNumberWithSpaces(rowData.budget.value.toFixed(0))} ${
              rowData.budget.currency
            }`}
          </Typography>
        </TableCell>
      </TableRow>
      <TableRow sx={{ borderBottom: isRowOpen ? '1px solid' : 'none', ...sx }}>
        <TableCell style={{ padding: 0 }} colSpan={8}>
          <Collapse in={isRowOpen} unmountOnExit>
            <Box sx={{ padding: '16px 0' }}>
              <NestedBudgetTable
                rowData={rowData.children}
                touchpoint={rowData.touchpoint}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default BudgetTableRow;
